import { FC, useMemo } from 'react'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { RootState } from '../../../store/types'
import { ClbSideMenu } from '@celebration/react'
import { MenuItem, SubMenuItem } from '@celebration/react/ClbSideMenu/ClbSideMenu.types'
import { Icons as ClbIconsOptions } from '@celebration/react/ClbIcon/props.types'
import { MfeRouteGroup, VisibleMfeRouteGroup } from '../../mfe/types'
import { Wrapper } from './styles/SideMenu.styles'

const MENUS_ICONS_NAMES: Record<VisibleMfeRouteGroup, ClbIconsOptions> = {
  [MfeRouteGroup.Freights]: 'report',
  [MfeRouteGroup.Financial]: 'file',
  [MfeRouteGroup.Register]: 'anotacoes',
  [MfeRouteGroup.Cockpit]: 'history',
  [MfeRouteGroup.Dochub]: 'download'
}

const SideMenu: FC = (): React.ReactElement => {
  const menus = useSelector((state: RootState) => state.mfe.menus)

  const items = useMemo((): MenuItem[] => {
    const homeItem: MenuItem = {
      icon: 'home',
      label: 'Início',
      to: '/',
    }

    const dynamicItems: MenuItem[] = menus.map((menu) => ({
      label: menu.name,
      icon: MENUS_ICONS_NAMES[menu.routeGroup],
      subMenuItems: menu.items.map(
        (subMenu, index): SubMenuItem => ({
          selectionLabel: index === 0 ? menu.name : undefined,
          label: subMenu.label,
          to: subMenu.path,
          type: 'link',
        }),
      ),
    }))

    return [homeItem, ...dynamicItems]
  }, [menus])

  return (
    <Wrapper>
      <ClbSideMenu
        Link={Link}
        items={items}
        locale={{
          subMenuToggleButtonTitle: 'Abrir/fechar menu',
          subMenuToggleButtonAriaLabel: 'Abrir/fechar menu lateral',
        }}
      />
    </Wrapper>
  )
}

export default SideMenu
